import texts from './m60sReportTexts.json'

// N8 专用词包，不修改 M8 和其他设备的共用翻译。
export function m60sReportText(locale, key) {
    const normalized = locale === 'pt-PTO' ? 'pt-PT' : locale
    return (texts[normalized] && texts[normalized][key]) ||
        (texts['en-US'] && texts['en-US'][key]) || key
}
